import { EABFilterImplementationType, type FilterOption } from "@/graphql";
import type { EventFilter, ActionFilter } from "../FilterTypes";
import CreatorFilterUI from "../ui/CreatorFilterUI.vue";
import CreatorFilterBadge from "../ui/badges/CreatorFilterBadge.vue";

export default class CreatorFilter implements EventFilter, ActionFilter {
  constructor(
    public readonly userIds: number[],
    public readonly isNegated?: boolean,
  ) {}

  static readonly Badge = CreatorFilterBadge;

  static readonly UI = CreatorFilterUI;

  getEventFilter(): FilterOption | undefined {
    // TODO Hide idea crator logic
    return {
      filter: {
        type: EABFilterImplementationType.EVENT_CREATOR_ID,
        value: {
          value: this.userIds,
          negated: this.isNegated ?? false,
        },
      },
    };
  }

  getActionFilter(): FilterOption | undefined {
    return {
      filter: {
        type: EABFilterImplementationType.ACTION_ASSIGNEE_ID,
        value: {
          value: this.userIds,
          negated: this.isNegated ?? false,
        },
      },
    };
  }
}
